import { Component, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AlertModalComponent } from '../../alert-modal//alert-modal.component';
import { S3Service } from '../../services/s3.service';

@Component({
  selector: 'app-source-document-dialog',
  template: `
    <h1 mat-dialog-title>{{ data.metadata.title }}</h1>
    <div mat-dialog-content>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Metadata</mat-panel-title>
        </mat-expansion-panel-header>
        <table class="metadata-table">
          <thead>
            <tr>
              <th colspan="2">Document Metadata</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of metadataKeys">
              <td>
                <strong>{{ key | titlecase }}</strong>
              </td>
              <td>{{ data.metadata[key] }}</td>
            </tr>
          </tbody>
        </table>
      </mat-expansion-panel>
      <div *ngIf="summaryContent" class="parsed-content">
        <h2>Summary</h2>
        <pre>{{ summaryContent }}</pre>
      </div>
      <div *ngIf="mainContent" class="parsed-content">
        <h2>Content</h2>
        <pre>{{ mainContent }}</pre>
      </div>
      <div *ngIf="citationImage" class="reference-images">
        <h2>Reference Page</h2>
        <div *ngIf="data?.citation_id">
          <h4>Citation ID: {{ data.citation_id }}</h4>
        </div>
        <div *ngIf="citationImage.citation?.document_title">
          <h4>Document Title: {{ citationImage.citation.document_title }}</h4>
        </div>
        <div *ngIf="citationImage.citation?.page_number">
          <h4>Page: {{ citationImage.citation.page_number }}</h4>
        </div>
        <div class="reference-image">
          <a [href]="citationImage.url" target="_blank">
            <img
              [src]="citationImage.url"
              alt="Citation Reference Page"
              style="max-width:100%; max-height:800px; margin-bottom: 1em;" />
          </a>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Close</button>
    </div>
  `,
  styles: [
    `
      pre {
        white-space: pre-wrap;
        word-wrap: break-word;
      }
      h1,
      strong {
        font-size: 1.1rem;
      }
      .image-content {
        text-align: center;
      }
      .image-content img {
        max-width: 100%;
        height: auto;
      }
    `
  ]
})
export class SourceDocumentDialogNewComponent implements AfterViewInit {
  metadataKeys: string[];
  summaryContent: string | null = null;
  mainContent: string | null = null;
  imgURL: string | null = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  citationImage: { url: string; citation: any } | null = null;

  constructor(
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private s3Service: S3Service
  ) {
    this.metadataKeys = Object.keys(this.data.metadata);

    // Parse the content
    this.parseContent(data.content);
    // fetch reference images for citations
    this.fetchReferenceImages(this.data.citation_data);
  }

  // TODO check use of empty hook.
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  ngAfterViewInit() {}

  parseContent(content: string): void {
    const summaryMatch = content.match(/<summary>([\s\S]*?)<\/summary>/);
    const contentMatch = content.match(/<content>([\s\S]*?)<\/content>/);

    this.summaryContent = summaryMatch ? summaryMatch[1].trim() : null;
    this.mainContent = contentMatch ? contentMatch[1].trim() : null;

    // Check if there is no content to display
    if (!this.summaryContent && !this.mainContent) {
      this.dialog.open(AlertModalComponent, {
        data: {
          title: 'No Content Available',
          message: 'There is no content available for this source document.'
        }
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchReferenceImages(citation_info: any): void {
    const citation = citation_info;
    this.s3Service.getPresignedUrl(citation.document_uri, citation.page_number ?? 1).subscribe({
      next: (url: string) => {
        this.citationImage = { url, citation };
      },
      error: err => {
        console.error('Error fetching presigned URL for citation:', err);
      }
    });
  }
}
